import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../configurations/configuration';
import { environment } from '../../../environments/environment';
import { UpcomingPrograms} from '../../models/upcoming-programs/upcoming-progrmas';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class UpcomingProgramsService {
  upcomingPrograms: string;
  constructor(private http: HttpClient) { 
    this.upcomingPrograms = environment.baseURI + environment.apiUrl + 'events/list';
  }

  
  getUpcomingEvents(sort, filterObj, limit, start): Observable<UpcomingPrograms> {
    return this.http.get<UpcomingPrograms>(this.upcomingPrograms + "?filter=" + encodeURIComponent(JSON.stringify(filterObj)) + "&limit=" + limit + "&start=" + start+"&sort="+encodeURIComponent(JSON.stringify(sort)), httpOptions);
  }
}
